import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import { parseDescriptionTemplate } from '../utils/Utils';
import useDescriptionTemplatesContext from './useDescriptionTemplatesContext';

const useTemplateParsing = (templates) => {
  const { t } = useFrameworkTranslation();
  const descriptionTemplates = useDescriptionTemplatesContext();

  const parseDescriptionFunction = (tId, metadata) =>
    parseDescriptionTemplate(
      templates || descriptionTemplates,
      t,
      tId,
      metadata
    );

  return parseDescriptionFunction;
};

export default useTemplateParsing;
